import { useState } from "react";
import HeroIcon from "./HeroIcon";
import { Workflow } from "./interface";
import { LightningBoltIcon } from "@heroicons/react/outline";

interface Props {
  workflow: Workflow;
  onSelect: (workflow: Workflow) => void;
}

function WorkflowCard(props: Props) {
  const { workflow } = props;
  const [showPreview, setShowPreview] = useState(true);

  return (
    <div className="w-56 h-48 rounded-lg border shadow hover:shadow-inner cursor-pointer flex flex-col overflow-hidden" onClick={() => props.onSelect(workflow)}>
      <div className="relative bg-gray-200 h-36 flex-shrink-0 pt-4 px-8 -z-10">
        <div className="absolute flex items-center justify-center w-full h-full top-2 left-0"><LightningBoltIcon className="w-20 h-20 text-gray-300" /></div>
        {(showPreview && workflow.previewFileId) &&
          <img className="relative rounded shadow w-full" onError={() => setShowPreview(false)} src={`https://drive.google.com/thumbnail?authuser=0&sz=w320&id=${workflow.previewFileId}`} alt="Thumbnail" />
        }
      </div>
      <div className="p-2 justify-center items-center font-semibold text-gray-600 flex gap-2 h-full bg-white border-t">
        <div className="flex items-center justify-center h-6 w-6 rounded flex-shrink-0" style={{ backgroundColor: workflow.color }}>
          <HeroIcon icon={workflow.icon} className="w-5 h-5 text-white" />
        </div>
        <div className="max-w-48 truncate text-sm">
          {workflow.name}
        </div>
      </div>
    </div>

  )
}

export default WorkflowCard;